<template>
  <div class="alertDetail">
    <form class="statusUpdateForm">
      <div class="form-group">
        <select name="" id="" class="form-control" v-model="activeStatus">
          <option disabled selected value="">{{$t("selectStatus")}}</option>
          <option v-for="(item, key) in statusList" :key="key" :value="item.id">
            {{ item.status }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <button
          type="button"
          class="ag-button_primary ag-button border-0 ag-button_radius"
          @click="changeSelected"
          :disabled="checkedRows.length === 0 || !activeStatus"
        >
          {{$t("changeSelected")}}
        </button>
      </div>
    </form>
    <div id="ag-table" class="dataTables_wrapper dt-bootstrap4 no-footer">
      <div class="table-responsive">
        <TableLite
          id="dataTables-example"
          class="table table-hover"
          :has-checkbox="true"
          :is-loading="table.isLoading"
          :columns="table.columns"
          :rows="table.rows"
          :total="table.totalRecordCount"
          @do-search="getList"
          @return-checked-rows="updateCheckedRows"
          @is-finished="tableLoadingFinish"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "@/store";
import api from "@/api/index";
import apiAxios from "@/store/axiosAgsc";
import moment from "moment";
import { AlertTypes } from "@/helpers/enums/AlertTypes";
import { AlertStatus } from "@/helpers/enums/AlertStatus";
import TableLite from "vue3-table-lite";
import { useI18n } from "vue-i18n";
import { reactive, ref } from "vue";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import axiosAgsc from "@/store/axiosAgsc";
import { notify } from "@kyvg/vue3-notification";

const store = useStore();
export default {
  name: "ag-scope-detail",
  props: {
    props: {
      data: {
        type: Array,
        default: null,
      },
      options: {
        type: Object,
        default: null,
      },
    },
  },
  components: {
    TableLite,
  },
  data() {
    return {
      activeStatus: "",
    };
  },
  setup() {
    const checkedRows = ref([]);
    const i18n = useI18n();
    const statusList = [
      {
        status: "Unresolved",
        id: 0,
      },
      {
        status: "In Review",
        id: 1,
      },
      {
        status: "Resolved",
        id: 2,
      },
    ];

    const table = reactive({
      isLoading: false,
      columns: [
        {
          field: "id",
          isKey: true,
          display: function () {
            return;
          },
        },
        {
          label: "Alert Type",
          field: "alarmType",
          sortable: false,
          display: function (row) {
            let rowType = row.type;
            if (rowType === 3) {
              rowType = 0;
            }
            return (
              '<span class="p-1 ag-ribbon ag-ribbon_' +
              AlertTypes[rowType] +
              '">' +
              i18n.t(AlertTypes[rowType]) +
              "</span>"
            );
          },
        },
        {
          label: "Status",
          field: "status",
          sortable: false,
          display: function (row) {
            return i18n.t(AlertStatus[row.status]);
          },
        },
        {
          label: "Endpoint",
          field: "source",
          sortable: false,
        },
        {
          label: "Condition",
          field: "ruleName",
          sortable: false,
          display: function (row, t) {
            if (row.type === 3) {
              return "Corrupted Files";
            } else {
              return row.ruleName;
            }
          },
        },
        {
          label: "Created At",
          sortable: false,
          display: function (row) {
            return `<div style="display: flex; flex-direction: column">
              <span>${moment(row.createdAt).format("L")}</span>
              <span>${moment(row.createdAt).format("hh:mm A")}</span>
            </div>`;
          },
        },
        {
          label: "Details",
          field: "edit",
          display: function (row) {
            if (!(row.eventJson && row.eventJson == "null") || row.details === "") {
              return "N/A";
            }
            if (row.type === 3) {
              return `<a href="javascript: void(0);" data-id="${row.id}" class="name-btn scopeDetails"><i class="ag-icon ag-icon_zoom_in"></i> Details</a>`;
            }
            return `<a href="javascript: void(0);" data-id="${row.id}" class="name-btn scopeHashDetail"><i class="ag-icon ag-icon_zoom_in"></i> Details</a>`;
          },
        },
        {
          label: "View XML",
          field: "view_xml",
          display: function (row, t) {
            if (row.type !== 3 || !row.fileContentPlain || row.fileContentPlain == "null") {
              return "N/A";
            }
            return `<a href="javascript: void(0);" data-id="${row.id}" class="name-btn scopeXmlAnchor"><i class="ag-icon ag-icon_code"></i> View XML</a>`;
          },
        },
        {
          label: "Download",
          field: "download",
          display: function (row, t) {
            if (row.type !== 3) {
              return "N/A";
            }
            if (!row.fileContentPlain || row.fileContentPlain == "null") {
              return "N/A";
            }
            return `<i data-id="${row.id}" class="download-icon ag-icon ag-icon_download cursor-pointer"></i>`;
          },
        },
      ],
      sortable: {
        order: "name",
        sort: "asc",
      },
    });

    localStorage.setItem("scopeDetail", "");
    localStorage.setItem("scopeAlertDetailData", "");

    const tableLoadingFinish = () => {
      let scopeHashDetail = document.querySelectorAll(".scopeHashDetail");
      table.isLoading = false;
      Array.prototype.forEach.call(scopeHashDetail, function (element) {
        if (element.classList.contains("scopeHashDetail")) {
          element.addEventListener("click", function () {
            if (document.getElementById("ag-tab_hashdetails")) {
              // document.getElementById("tab_hashdetails").children[1].style.display = "unset";
              document.getElementById("ag-tab").children[3].style.display = "unset";
              document.getElementById("ag-tab").children[4].style.display = "unset";

              document.getElementById("ag-tab_hashdetails").click();
            }

            const id = this.getAttribute("data-id");
            const data = table.rows.find((i) => (i.id = id));
            let json = data.details;
            try {
              json = JSON.parse(data.details);
            } catch (error) {
              console.log(error);
              json = {};
            }

            const stateData = store.state.general.selectedExpandedRow;
            stateData.hash = json.data.id;
            store.dispatch(GeneralActionTypes.SET_SELECTED_ROW, stateData);
          });
        }
      });

      let elements = document.querySelectorAll(".scopeDetailAnchor");
      table.isLoading = false;
      Array.prototype.forEach.call(elements, function (element) {
        if (element.classList.contains("scopeDetailAnchor")) {
          element.addEventListener("click", function () {
            if (document.getElementById("ag-tab_scopedetails")) {
              // document.getElementById("tab_scopedetails").children[1].style.display = "unset";
              document.getElementById("ag-tab").children[1].style.display =
                "unset";

              document.getElementById("ag-tab_scopedetails").click();
            }
            const id = this.getAttribute("data-id");
            const data = table.rows.find((i) => (i.id = id));
            let json = data.eventJson;
            try {
              json = JSON.parse(data.eventJson);
            } catch (error) {
              console.log(error);
              json = {};
            }
            localStorage.setItem("scopeDetail", JSON.stringify(json));
          });
        }
      });

      let detailElements = document.querySelectorAll(".scopeDetails");
      table.isLoading = false;
      Array.prototype.forEach.call(detailElements, function (element) {
        if (element.classList.contains("scopeDetails")) {
          element.addEventListener("click", function () {
            if (document.getElementById("ag-tab_scopedetails")) {
              document.getElementById("ag-tab").children[1].style.display =
                "unset";

              document.getElementById("ag-tab_scopedetails").click();
            }
            const id = this.getAttribute("data-id");
            const data = table.rows.find((i) => (i.id = id));
            let json = data.eventJson;
            try {
              json = JSON.parse(data.details);
            } catch (error) {
              console.log(error);
              json = {};
            }
            localStorage.setItem("scopeDetail", JSON.stringify(json));
          });
        }
      });

      let xmlElements = document.querySelectorAll(".scopeXmlAnchor");
      table.isLoading = false;
      Array.prototype.forEach.call(xmlElements, function (element) {
        if (element.classList.contains("scopeXmlAnchor")) {
          element.addEventListener("click", function () {
            if (document.getElementById("ag-tab_xml")) {
              // document.getElementById("ag-tab_xml").innerHTML = 'XML';
              document.getElementById("ag-tab").children[2].style.display =
                "unset";
              document.getElementById("ag-tab_xml").click();
            }
            const id = this.getAttribute("data-id");
            const data = table.rows.find((i) => (i.id = id));
            localStorage.setItem("scopeAlertDetailData", JSON.stringify(data));
          });
        }
      });

      let downloadElements = document.querySelectorAll(".download-icon");
      Array.prototype.forEach.call(downloadElements, function (element) {
        if (element.classList.contains("download-icon")) {
          element.addEventListener("click", function () {
            let id = element.getAttribute("data-id");
            let url = `/Alarm/DownloadCorruptedFileObject?id=${id}`;
            axiosAgsc
              .api({
                url: url,
                methods: "GET",
              })
              .then((response) => {
                const url = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                  "download",
                  response.data.entityData.fileName
                );
                document.body.appendChild(link);
                link.click();
              });
          });
        }
      });
    };

    const updateCheckedRows = function (rowsKey) {
      checkedRows.value = rowsKey;
    };

    return {
      statusList,
      table,
      tableLoadingFinish,
      updateCheckedRows,
      checkedRows,
    };
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  watch: {
    selectedRow() {
      this.getList(0, 10, "id", "asc");
    },
  },
  async mounted() {
    if (document.getElementById("ag-tab_xml")) {
      // document.getElementById("ag-tab_xml").innerHTML = '';
      document.getElementById("ag-tab").children[2].style.display = "none";
    }

    if (document.getElementById("ag-tab_scopedetails")) {
      document.getElementById("ag-tab").children[1].style.display = "none";
    }

    if (document.getElementById("ag-tab_hashdetails")) {
      document.getElementById("ag-tab").children[3].style.display = "none";
    }

    if (document.getElementById("ag-tab_whereFound")) {
      document.getElementById("ag-tab").children[4].style.display = "none";
    }

    await this.getList(0, 10, "id", "asc");
  },
  methods: {
    async getList(offset, limit, order, sort) {
      if(!this.selectedRow.filterData.startDate) {
        return;
      }
      const data = {
        page: offset / limit + 1,
        limit: limit,
        startDate: this.selectedRow.filterData.startDate,
        endDate: this.selectedRow.filterData.endDate,
        alarmType: this.selectedRow.type,
        severity: null,
        status: this.selectedRow.status,
        source: this.selectedRow.source,
        ruleName: this.selectedRow.ruleName,
        description: this.selectedRow.description,
        sortColumn: "",
        sortDir: "",
        groupGuids: [],
      };
      this.table.isLoading = true;
      const res = await api.alarms.getAlarmsWithDetail(data);
      this.table.rows = res.data.entityData;
      this.table.totalRecordCount = res.data.totalCount;
      this.table.isLoading = false;
    },
    changeSelected() {
      if (this.checkedRows.length > 0) {
        apiAxios
          .put("/Alarm/UpdateAlarmStatuses", {
            alarmIds: this.checkedRows,
            status: Number(this.activeStatus),
          })
          .then((response) => {
            notify({
              title: "Alarm status has been changed successfully",
              type: "success",
              duration: 4000,
            });
            this.activeStatus = '';
            this.checkedRows = []
            let checkboxes = document.querySelectorAll(
              ".vtl-table input[type='checkbox']"
            );
            checkboxes.forEach((item) => {
              item.checked = false;
            });
            this.getList(0, 10, "id", "");
          });
      }
    },
  },
};
</script>

<style lang="scss">
.alertDetail {
  font-size: 15px;
}

.alertDetail .table-responsive > .card {
  padding: 0;
}

.alertDetail .statusUpdateForm {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.alertDetail .statusUpdateForm button {
  margin-left: 15px;
  font-weight: normal;
  padding: 0.375rem 0.75rem;
}

.alertDetail .table-responsive select {
  margin: 0 7.5px;
}

.alertDetail .table-responsive div[role="status"] {
  font-size: 13px;
}

.alertDetail
  .table-responsive
  .pagination
  .page-item.disabled:not(:nth-child(1)):not(:nth-child(2)):not(:nth-last-child(1)):not(:nth-last-child(2))
  a {
  background: #4c8dbb;
  color: #fff !important;
}

.alertDetail .table-responsive .pagination .page-item.disabled a:focus,
.alertDetail .table-responsive .pagination .page-item.disabled a:hover {
  box-shadow: none !important;
  outline: none !important;
}
.name-btn {
  display: flex;
  align-items: center;
  i {
    margin-right: 4px;
  }
}
</style>
